// Utils
import { createQueryString } from '../../../../../common/utils/stringUtil';
import tokenizeQuery from '../../../../../common/search/tokenizeQuery';

// Constants
import { APP_QUERY_PARAMS } from '../../../../../common/utils/urlConstants';

const getResultUrl = ({ result, searchQuery, permissionId, currentBoardId }) => {
    const boardId = result.dontNavigateOnSelect ? currentBoardId : result.id;

    const filter = { filter_query: tokenizeQuery(searchQuery).query };

    if (permissionId) {
        filter[APP_QUERY_PARAMS.PERMISSION] = permissionId;
    }

    const queryString = createQueryString(filter);
    const urlQuery = queryString ? `?${queryString}` : '';
    return `/${boardId}${urlQuery}`;
};

export default getResultUrl;
